module.exports = __webpack_public_path__ + "static/media/GrupoZelo_horizontal.c1b203e9.jpg";